import {inject, Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, RouterStateSnapshot} from "@angular/router";
import {DashboardStore} from "@widgets/dashboard";
import {EditingWidget, WidgetConstructorStore} from "@widgets/widget-constructor";
import {DashboardMapperService} from "./dashboard.mapper.service";

@Injectable({providedIn: "root"})
export class CanConstructorActivate implements CanActivate {
    dbStore = inject(DashboardStore);
    constructorStore = inject(WidgetConstructorStore);
    mapper = inject(DashboardMapperService);

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        let widget: EditingWidget;
        const id = state.url.split("/").at(-1)!;

        const dto = this.dbStore.getWidget(id);
        if (dto) {
            widget = this.mapper.mapWidgetToEditingWidget(dto);
        } else {
            widget = this.mapper.createNewEditingWidget();
        }

        this.constructorStore.setEditingWidget(widget);
        return true;
    }
}
